import React from "react";

import "./ChartIcons.scss";

const MultiPlot = props => {
  const getClassName = () => {
    const styleClass = "chart-icon";
    return props.active && !props.disabled ? `${styleClass}-active` : styleClass;
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" className={getClassName()} disabled={props.disabled}>
      <g id="Multi_Plot" data-name="Multi Plot" transform="translate(0.5 0.5)">
        <g id="Group_15139" data-name="Group 15139">
          <path id="margin" fill="#fff" stroke="#707070" opacity="0" d="M0 0H32V32H0Z" />
          <path
            id="Path_12996"
            data-name="Path 12996"
            className="icon-fill"
            d="M20.5 8l1.336 1.336-2.847 2.847L16.656 9.849l-4.323 4.329.823.822 3.5-3.5 2.333 2.333 3.675-3.669L24 11.5V8Z"
          />
          <path
            id="Path_12997"
            data-name="Path 12997"
            className="icon-fill"
            d="M15.5 24l-1.336-1.336 2.847-2.847 2.333 2.334 4.323-4.329L22.844 17l-3.5 3.5-2.333-2.333-3.675 3.669L12 20.5V24Z"
          />
          <line
            id="Line_305"
            data-name="Line 305"
            fill="none"
            className="icon-stroke"
            strokeLinecap="square"
            strokeMiterlimit="10"
            y2="15"
            transform="translate(8 8.5)"
          />
        </g>
      </g>
    </svg>
  );
};

export default MultiPlot;
